export const NOT_EXISTING_MEMBER_NAME = "no name";
